var top = $('#top');
$(window).scroll(function(){
   var percent = $(document).scrollTop() / ($(document).height() - $(window).height());
   top.css('opacity', 0 + percent);
});
top.on('click', function() {
  $('body,html').animate({
    scrollTop : 0
  }, 500);
});
